<template>
  <v-list class="py-0">
    <v-list-tile :style="panelColour">
      <v-list-tile-avatar size="20" class="list-avatar-icon">
        <v-tooltip bottom>
          <v-icon :color="panelColour.color" slot="activator" id="template-information" aria-label="template-information">info</v-icon>
          <span>{{info}}</span>
        </v-tooltip>
      </v-list-tile-avatar>
      <v-list-tile-content>
        {{title}}
      </v-list-tile-content>
      <v-list-tile-avatar class="pr-3">
        <v-layout align-center>
          <v-checkbox :id="checkboxId" role="checkbox" :aria-label="checkboxId"
                      v-model="checkbox"
                      :color="panelColour.color"
                      hide-details
                      dark></v-checkbox>
          <span class="pl-2">{{$t('admin.alerts.new.email_templates.all')}}</span>
        </v-layout>
      </v-list-tile-avatar>
    </v-list-tile>
  </v-list>
</template>
<script>
  export default {
    name: 'alert-header-panel',
    props: {
      checkboxValue: {
        type: Boolean,
        default: false
      },
      panelColour: {
        type: Object
      },
      panelType: {
        type: Object
      },
      checkboxId: {
        type: String
      }
    },
    computed: {
      title () {
        return this.$t(this.panelType.title)
      },
      info () {
        return this.$t(this.panelType.info)
      },
      checkbox: {
        get () {
          return this.checkboxValue
        },
        set (value) {
          this.$emit('set-checkbox', value)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertHeaderPanel.vue